module.exports = __webpack_public_path__ + "img/tea-cup.9db9a880.png";